import session from './session';

const KEY = 'postLoginRedirect';

// A destination stashed longer ago than this is stale — someone returning the
// next day expects /inbox, not the page they were bounced off yesterday.
const MAX_AGE_MS = 30 * 60 * 1000;

// In-app absolute paths only. '//host' is rejected because the browser reads it
// as protocol-relative and would navigate off-site.
const isSafePath = path =>
	typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

/**
 * Remember where the user was heading before the auth guard bounced them to
 * /login, so the login can hand them back to it.
 */
export const stashPostLoginRedirect = location => {
	if (!location) return;

	const path = `${location.pathname || ''}${location.search || ''}`;

	if (!isSafePath(path) || path.startsWith('/login')) return;

	session.set(KEY, { path, at: Date.now() });
};

/**
 * Read and clear the stashed destination. Returns null when there is nothing
 * pending or the stash has gone stale.
 */
export const takePostLoginRedirect = () => {
	let stash;

	try {
		stash = session.get(KEY);
	} catch {
		stash = null;
	}

	session.unset(KEY);

	if (!stash || !isSafePath(stash.path)) return null;
	if (!stash.at || Date.now() - stash.at > MAX_AGE_MS) return null;

	return stash.path;
};
